import React, {useState, useEffect} from "react"
import {Select} from "@irati/ui/src/FormItem"
import {useCustomRewardsQuery} from "@irati/custom-reward/hooks"
import Flex from "@irati/ui/src/Flex"
import Error from "@irati/ui/src/Loading/Error"
interface Props {
  onChange: (customRewardId: string) => void
  defaultValue?: string | null
  regions?: string[]
}
type CustomRewardsOption = {
  value: string
  label: string
}
const CustomRewardSelect = (props: Props) => {
  const {onChange, defaultValue, regions} = props
  const [customRewardOptions, setCustomRewardOptions] = useState<CustomRewardsOption[]>()
  const [selectedCustomRewardOption, setSelectedCustomRewardOption] = useState<CustomRewardsOption>()
  const {data} = useCustomRewardsQuery(
    {
      locations: regions
    },
    {fetchPolicy: "cache-and-network"}
  )
  useEffect(() => {
    if (!data) return
    const newCustomRewardsOptions = data.map((customReward) => ({
      value: customReward.uuid,
      label: customReward.title
    }))
    setCustomRewardOptions(newCustomRewardsOptions)
    if (defaultValue) {
      const defaultSelectedCustomRewardOption = newCustomRewardsOptions.find(({value}) => defaultValue === value)
      setSelectedCustomRewardOption(defaultSelectedCustomRewardOption)
    }
    if (selectedCustomRewardOption) {
      const isIncludedSelectedCustomReward = newCustomRewardsOptions.some(({value}) => selectedCustomRewardOption.value === value)
      if (!isIncludedSelectedCustomReward) {
        setSelectedCustomRewardOption(null)
      }
    }
  }, [data])
  const onSelectCustomReward = (customRewardId: string) => {
    const newSelectedCustomRewardOption = customRewardOptions?.find(({value}) => customRewardId === value)
    setSelectedCustomRewardOption(newSelectedCustomRewardOption)
    onChange(customRewardId)
  }
  return (
    <Flex direction="column" marginBottom={2}>
      <Select
        id="selectRewardType"
        isClearable={false}
        isSearchable={false}
        options={customRewardOptions}
        hideLabel
        flush
        name="selectRewardType"
        placeholder="recognition.reward.types.placeholder"
        onChange={onSelectCustomReward}
        value={selectedCustomRewardOption}
      />
      {customRewardOptions?.length === 0 && <Error errorMsg="platform.recognition.customReward.noCustomRewards" />}
    </Flex>
  )
}

export default CustomRewardSelect
